import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/v4ward/group/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/v4ward/group/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
request.post('/api/v4ward/group/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/v4ward/group/submit', params,options);

export const update = (params, options) =>
request.post('/api/v4ward/group/submit', params,options);




export const saveAddFormData = (params, options) =>
request.post('/api/v4ward/group/save', params,options);


export const saveEditFormData = (params, options) =>
request.post('/api/v4ward/group/update', params,options);

export const getDepartmentTreeList = (params, options) =>
request.get('/api/v4ward/dept/treeByIds', Object.assign({}, options, { params }));

// export const getUserListByDepartmentId = (params, options) =>
// request.get('/api/v4ward/user/user-list-by-dept', Object.assign({}, options, { params }));

export const getUserListByDepartmentId = (params, options) =>
request.get('/api/v4ward/user/dept-user-list', Object.assign({}, options, { params }));

export const getProjectList = (params, options) =>
request.get('/api/v4ward/project/getProjectList', Object.assign({}, options, { params }));




export const getGroupList = (params, options) =>
request.get('/api/v4ward/group/getGroupList', Object.assign({}, options, { params }));




export const getPrincipalUserList = (params, options) =>
request.get('/api/v4ward/groupUser/getPrincipalUserList', Object.assign({}, options, { params }));

export const getMenberUserList = (params, options) =>
request.get('/api/v4ward/groupUser/getMenberUserList', Object.assign({}, options, { params }));




// export const getMenberUserList = (params, options) =>
// request.get('/api/v4ward/user/dept-user-list', Object.assign({}, options, { params }));

export const treeByProjectDeptId = (params, options) =>
  request.get('/api/v4ward/dept/treeByProjectDeptId', Object.assign({}, options, { params }));

// 根据项目id、工单类型获取该班组成员 /v4ward/group/getGroupListByModuleType
export const getGroupListByModuleType = (params, options) =>
  request.get('/api/v4ward/group/getGroupListByModuleType', Object.assign({}, options, { params }));



